import React, { useEffect, useState } from 'react';
// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Autocomplete,
    Avatar,
    Box,
    Button,
    ButtonBase,
    CardActions,
    CardContent,
    CircularProgress,
    Divider,
    Grid,
    IconButton,
    InputAdornment,
    InputBase,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Paper,
    Skeleton,
    Stack,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
    Typography
} from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
// project imports
import MainCard from 'ui-component/cards/MainCard';
import SkeletonPopularCard from 'ui-component/cards/Skeleton/TotalGrowthBarChart';
import { gridSpacing } from 'store/constant';
import ApiLink from 'API';
import axios from 'axios';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useNavigate } from 'react-router';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import ArticleIcon from '@mui/icons-material/Article';
import moment from 'moment';
import { exportToCSV } from 'ui-component/exportToCSV';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { MobileDateTimePicker } from '@mui/x-date-pickers';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const StockCard = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [isLoading, setisLoading] = useState(false);
    const [SumCount, setSumCount] = useState(0);
    const [Value, setValue] = useState('');
    const [Data, setData] = useState([]);
    const [Datasearch, setDatasearch] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [DataLocation, setDataLocation] = useState([{ locationCode: '^', Name: 'ALL' }]);
    const [SelectLocation, setSelectLocation] = useState({ locationCode: '^', Name: 'ALL' });
    const [open, setOpen] = React.useState(false);
    const [loading, setloading] = React.useState(false);
    const [DateFilterInventory, setDateFilterInventory] = useState(new Date());
    const [typeFilter, setTypeFilter] = useState('all'); // 'all' | 'normal' | 'display'
    // true once the user applies a date/location filter — so changing Type
    // re-runs the date/location query (not the plain current-stock endpoint).
    const [filterActive, setFilterActive] = useState(false);
    // Card view mode: 'inventory' (phones, as before) | 'premiums' (premium gifts).
    const [viewMode, setViewMode] = useState('inventory');
    const [Premiums, setPremiums] = useState([]);
    const [PremiumLoc, setPremiumLoc] = useState('^'); // premium stock location filter
    const [premiumLoading, setPremiumLoading] = useState(false);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleChangeDateFilterInventory = (value) => {
        setDateFilterInventory(value);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    useEffect(() => {
        let isMounted = true;

        const LoadDataLocation = async () => {
            try {
                setloading(true);
                const response = await axios.get(ApiLink + '/api/consignment/all/^', {
                    withCredentials: true,
                    headers: { token: localStorage.getItem('token') }
                });
                if (isMounted) {
                    if (response.status === 200) {
                        const data = [{ locationCode: '^', Name: 'ALL' }];
                        setDataLocation(data.concat(response.data.data || []));
                        setloading(false);
                    } else if (response.status === 401) {
                        localStorage.clear();
                        navigate(0);
                    }
                }
            } catch (error) {
                if (isMounted) {
                    setloading(false);
                    if (error?.response?.status === 401) {
                        localStorage.clear();
                        navigate(0);
                    }
                }
            }
        };

        LoadDataLocation();

        return () => { isMounted = false; };
    }, []);

    // Inventory list — re-fetched whenever the display/normal/both type filter changes.
    // If a date/location filter is active, re-run THAT query with the new type
    // (otherwise the location/saleDate selection would be lost on type change).
    useEffect(() => {
        let isMounted = true;
        if (filterActive) {
            LoadDataFilterDate({ Datevalue: DateFilterInventory, Location: SelectLocation.locationCode });
            return () => { isMounted = false; };
        }
        const LoadData = async () => {
            try {
                setisLoading(true);
                const response = await axios.get(ApiLink + '/api/dashboard/sale/inventory?type=' + typeFilter, {
                    withCredentials: true,
                    headers: { token: localStorage.getItem('token') }
                });
                if (isMounted) {
                    if (response.status === 200) {
                        const responseData = response.data.data || [];
                        setDatasearch(responseData);
                        setData(responseData);
                        const SumValue = responseData.map((item) => item.qty || 0).reduce((prev, next) => prev + next, 0);
                        setSumCount(SumValue);
                        setisLoading(false);
                    } else if (response.status === 401) {
                        localStorage.clear();
                        navigate(0);
                    }
                }
            } catch (error) {
                if (isMounted) {
                    setisLoading(false);
                    if (error?.response?.status === 401) {
                        localStorage.clear();
                        navigate(0);
                    }
                }
            }
        };
        LoadData();
        return () => { isMounted = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [typeFilter]);

    const LoadDataFilterDate = async (value) => {
        setAnchorEl(null);
        setFilterActive(true);
        try {
            setisLoading(true);
            const response = await axios.get(
                ApiLink + '/api/dashboard/sale/inventory/filter/' + value.Location + '/' + new Date(value.Datevalue) + '?type=' + typeFilter,
                {
                    withCredentials: true,
                    headers: { token: localStorage.getItem('token') }
                }
            );
            if (response.status === 200) {
                const responseData = response.data.data || [];
                setDatasearch(responseData);
                setData(responseData);
                const SumValue = responseData.map((item) => item.qty || 0).reduce((prev, next) => prev + next, 0);
                setSumCount(SumValue);
                setisLoading(false);
            } else if (response.status === 401) {
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            setisLoading(false);
            if (error?.response?.status === 401) {
                localStorage.clear();
                navigate(0);
            }
        }
    };

    const ExportEachItem = async () => {
        setAnchorEl(null);
        try {
            setisLoading(true);
            const response = await axios.get(
                ApiLink + '/api/dashboard/export/inventory/filter/' + SelectLocation.locationCode + '/' + new Date(DateFilterInventory),
                {
                    withCredentials: true,
                    headers: { token: localStorage.getItem('token') }
                }
            );
            if (response.status === 200) {
                const filename = 'Inventory-Aone-each-item-' + SelectLocation?.Name + '-' + moment(DateFilterInventory).format('YYYY-MM-DD-HH:mm:ss');
                if (response.data.data && response.data.data.length > 0) {
                    const transformedData = response.data.data.flatMap((product) =>
                        (product.stockcontrollers || []).map((stock) => ({
                            _id: stock._id,
                            productId: stock.productId,
                            model: product.model,
                            productName: product.productName,
                            color: product.color,
                            imei: stock.imei,
                            agentID: stock.agentID,
                            importPrice: stock.importPrice,
                            salePrice: stock.salePrice,
                            rateImport: stock.rateImport,
                            importDate: moment(stock.importDate).format('DD-MM-yyyy HH:mm'),
                            receiptNumber: stock.receiptNumber,
                            referenceInvoice: stock?.referenceInvoice,
                            branchCode: stock.branchCode,
                            CurrentlocationCode: stock.CurrentlocationCode,
                            type: stock.type,
                            locationCode: stock.locationCode
                        }))
                    );
                    exportToCSV(transformedData, filename);
                }
                setisLoading(false);
            } else if (response.status === 401) {
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            setisLoading(false);
            if (error?.response?.status === 401) {
                localStorage.clear();
                navigate(0);
            }
        }
    };

    useEffect(() => {
        if (Value !== '') {
            const data = Data.filter(
                (item) =>
                    item.productName.toLowerCase().includes(Value.toLowerCase()) ||
                    item.productId.toLowerCase().includes(Value.toLowerCase()) ||
                    item.model.toLowerCase().includes(Value.toLowerCase())
            );
            setDatasearch(data);
        } else {
            setDatasearch(Data);
        }
    }, [Value, Data]);

    // Premium stock list (per-location qty). Loaded when the card is in Premiums
    // mode or the location filter changes. Rows with qty 0 are hidden.
    useEffect(() => {
        let isMounted = true;
        if (viewMode !== 'premiums') return () => { isMounted = false; };
        const loadPremiums = async () => {
            try {
                setPremiumLoading(true);
                const response = await axios.get(ApiLink + '/api/premiums/stock/exportall?withImage=1&locationCode=' + PremiumLoc, {
                    withCredentials: true,
                    headers: { token: localStorage.getItem('token') }
                });
                if (!isMounted) return;
                if (response.status === 200) {
                    const rows = (response.data.data || [])
                        .map((p) => ({ ...p, qty: Number(p.qty || 0) }))
                        .filter((p) => p.qty > 0)
                        .sort((a, b) => b.qty - a.qty);
                    setPremiums(rows);
                } else if (response.status === 401) {
                    localStorage.clear();
                    navigate(0);
                }
            } catch (error) {
                if (isMounted && error?.response?.status === 401) {
                    localStorage.clear();
                    navigate(0);
                }
            } finally {
                if (isMounted) setPremiumLoading(false);
            }
        };
        loadPremiums();
        return () => { isMounted = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [viewMode, PremiumLoc]);

    // Premium list filtered by the search box.
    const PremiumSearch = React.useMemo(() => {
        const v = (Value || '').toLowerCase();
        if (!v) return Premiums;
        return Premiums.filter(
            (p) =>
                (p.premiumName || '').toLowerCase().includes(v) ||
                (p.premium_id || '').toLowerCase().includes(v) ||
                (p.color || '').toLowerCase().includes(v)
        );
    }, [Value, Premiums]);
    const PremiumSum = React.useMemo(() => Premiums.reduce((s, p) => s + Number(p.qty || 0), 0), [Premiums]);

    if (isLoading) {
        return (
            <MainCard content={false} sx={{ height: 'calc(100vh - 280px)', minHeight: 480, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <CardContent sx={{ flex: 1 }}>
                    <Stack spacing={1.5}>
                        <Skeleton variant="text" width="40%" height={28} />
                        <Skeleton variant="rectangular" height={20} />
                        {[...Array(8)].map((_, i) => (
                            <Stack key={i} direction="row" spacing={2} alignItems="center">
                                <Skeleton variant="rectangular" width={40} height={40} />
                                <Stack sx={{ flex: 1 }}>
                                    <Skeleton variant="text" width="70%" />
                                    <Skeleton variant="text" width="40%" />
                                </Stack>
                                <Skeleton variant="text" width={50} />
                            </Stack>
                        ))}
                    </Stack>
                </CardContent>
            </MainCard>
        );
    }

    return (
        <MainCard content={false} sx={{ height: 'calc(100vh - 280px)', minHeight: 480, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    <CardContent>
                        <Grid container spacing={gridSpacing}>
                            <Grid item xs={12}>
                                {/* Always 2 rows (title row, controls row) — this card sits in a
                                    2-column dashboard grid, so its rendered width is narrow even on
                                    desktop; viewport-based sm/md breakpoints don't reflect that and
                                    cause the controls to squeeze/overlap. */}
                                <Stack
                                    direction="column"
                                    spacing={1}
                                    justifyContent="space-between"
                                    alignItems="flex-start"
                                    sx={{ width: '100%' }}
                                >
                                    <Box>
                                        <Stack direction="row-reverse" alignItems="center">
                                            {viewMode === 'inventory' && (
                                                <MoreHorizOutlinedIcon
                                                    fontSize="small"
                                                    sx={{ color: theme.palette.primary[200], cursor: 'pointer' }}
                                                    aria-controls="menu-popular-card"
                                                    aria-haspopup="true"
                                                    onClick={handleClick}
                                                />
                                            )}
                                            <Menu
                                                id="menu-popular-card"
                                                anchorEl={anchorEl}
                                                keepMounted
                                                open={Boolean(anchorEl)}
                                                onClose={handleClose}
                                                variant="selectedMenu"
                                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                            >
                                                <MenuItem
                                                    key={1}
                                                    onClick={async () => {
                                                        setAnchorEl(null);
                                                        const filename = 'Inventory-Aone-' + SelectLocation?.Name + '-' + moment(DateFilterInventory).format('YYYY-MM-DD-HH:mm:ss');
                                                        const dataExcel = Datasearch.map((item) => ({
                                                            productId: item.productId,
                                                            productName: item.productName,
                                                            model: item.model,
                                                            color: item.color,
                                                            branchCode: item.branchCode,
                                                            qty: item.qty,
                                                            importPrice: item.importPrice,
                                                            rateImport: item.qty > 0 ? Number(item.rateImport) / Number(item.qty) : 0,
                                                            salePrice: item.salePrice
                                                        }));
                                                        exportToCSV(dataExcel, filename);
                                                    }}
                                                >
                                                    <ListItemIcon><ArticleIcon fontSize="small" color="success" /></ListItemIcon>
                                                    <ListItemText>Export Excel</ListItemText>
                                                </MenuItem>
                                                <MenuItem key={2} onClick={ExportEachItem}>
                                                    <ListItemIcon><ArticleIcon fontSize="small" color="primary" /></ListItemIcon>
                                                    <ListItemText>Export Each Item</ListItemText>
                                                </MenuItem>
                                                <MenuItem>
                                                    <LocalizationProvider dateAdapter={AdapterMoment}>
                                                        <MobileDateTimePicker
                                                            label="Inventory Date"
                                                            inputFormat="DD-MM-YYYY HH:mm:ss"
                                                            value={DateFilterInventory}
                                                            onChange={handleChangeDateFilterInventory}
                                                            onAccept={() => LoadDataFilterDate({ Datevalue: DateFilterInventory, Location: SelectLocation.locationCode })}
                                                            renderInput={(params) => <TextField size="small" {...params} />}
                                                        />
                                                    </LocalizationProvider>
                                                </MenuItem>
                                                <MenuItem>
                                                    <Autocomplete
                                                        size="small"
                                                        id="locationCode"
                                                        sx={{ minWidth: 300 }}
                                                        defaultValue={SelectLocation}
                                                        onChange={(event, newValue) => {
                                                            const loc = newValue || { locationCode: '^', Name: 'ALL' };
                                                            setSelectLocation(loc);
                                                            LoadDataFilterDate({ Datevalue: DateFilterInventory, Location: loc.locationCode });
                                                        }}
                                                        open={open}
                                                        onOpen={() => setOpen(true)}
                                                        onClose={() => setOpen(false)}
                                                        getOptionLabel={(option) => option.locationCode + '(' + option.Name + ')'}
                                                        options={DataLocation}
                                                        loading={loading}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                size="small"
                                                                label="Location"
                                                                InputProps={{
                                                                    ...params.InputProps,
                                                                    endAdornment: (
                                                                        <React.Fragment>
                                                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                                            {params.InputProps.endAdornment}
                                                                        </React.Fragment>
                                                                    ),
                                                                    startAdornment: (
                                                                        <InputAdornment position="start"><LocationOnIcon /></InputAdornment>
                                                                    )
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                </MenuItem>
                                            </Menu>
                                            <Stack direction="row" spacing={1.5} alignItems="center">
                                                <ToggleButtonGroup
                                                    size="small"
                                                    exclusive
                                                    color="primary"
                                                    value={viewMode}
                                                    onChange={(e, v) => v && setViewMode(v)}
                                                    sx={{
                                                        '& .MuiToggleButton-root': {
                                                            textTransform: 'none',
                                                            fontWeight: 500,
                                                            px: 1.5,
                                                            py: 0.4
                                                        }
                                                    }}
                                                >
                                                    <ToggleButton value="inventory">Inventory</ToggleButton>
                                                    <ToggleButton value="premiums">Premiums</ToggleButton>
                                                </ToggleButtonGroup>
                                                <Typography variant="h4">
                                                    {'(' + (viewMode === 'inventory' ? SumCount : PremiumSum) + ')'}
                                                </Typography>
                                            </Stack>
                                        </Stack>
                                    </Box>
                                    <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>
                                        <Stack direction="row" spacing={1} alignItems="center" sx={{ width: { xs: '100%', sm: 'auto' } }}>
                                            {viewMode === 'inventory' ? (
                                                <TextField
                                                    select
                                                    size="small"
                                                    label="Type"
                                                    value={typeFilter}
                                                    onChange={(e) => setTypeFilter(e.target.value)}
                                                    sx={{ minWidth: 110 }}
                                                >
                                                    <MenuItem value="all">All</MenuItem>
                                                    <MenuItem value="normal">Normal</MenuItem>
                                                    <MenuItem value="display">Display</MenuItem>
                                                    <MenuItem value="repaired">Repaired</MenuItem>
                                                </TextField>
                                            ) : (
                                                <TextField
                                                    select
                                                    size="small"
                                                    label="Location"
                                                    value={PremiumLoc}
                                                    onChange={(e) => setPremiumLoc(e.target.value)}
                                                    sx={{ minWidth: 150 }}
                                                >
                                                    {DataLocation.map((loc) => (
                                                        <MenuItem key={loc.locationCode} value={loc.locationCode}>
                                                            {loc.locationCode === '^' ? 'ALL (ລວມ)' : loc.locationCode + ' — ' + loc.Name}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            )}
                                            <Paper sx={{ display: 'flex', flex: 1, width: { xs: '100%', sm: 200 } }} elevation={2}>
                                                <InputBase
                                                    fullWidth
                                                    style={{ marginLeft: 8, flex: 1 }}
                                                    value={Value}
                                                    onChange={(e) => setValue(e.target.value)}
                                                    placeholder="Search..."
                                                    startAdornment={
                                                        <IconButton onClick={() => setValue('')} size="small"><RefreshIcon /></IconButton>
                                                    }
                                                />
                                            </Paper>
                                        </Stack>
                                    </Box>
                                </Stack>
                            </Grid>
                            <Grid item xs={12}>
                                <PerfectScrollbar
                                    options={{ suppressScrollX: true }}
                                    style={{ height: '100%', maxHeight: 'calc(100vh - 380px)', minHeight: 320, overflowX: 'hidden' }}
                                >
                                    {viewMode === 'premiums' ? (
                                        premiumLoading ? (
                                            <Stack spacing={1.5} sx={{ p: 1 }}>
                                                {[...Array(6)].map((_, i) => (
                                                    <Stack key={i} direction="row" spacing={2} alignItems="center">
                                                        <Skeleton variant="rectangular" width={40} height={40} />
                                                        <Skeleton variant="text" sx={{ flex: 1 }} />
                                                        <Skeleton variant="text" width={40} />
                                                    </Stack>
                                                ))}
                                            </Stack>
                                        ) : PremiumSearch.length === 0 ? (
                                            <Typography variant="body2" color="textSecondary" sx={{ p: 2, textAlign: 'center' }}>
                                                ບໍ່ມີ premium stock ທີ່ location ນີ້
                                            </Typography>
                                        ) : (
                                            PremiumSearch.map((item, index) => (
                                                <div key={item.premium_id || index}>
                                                    <Stack direction="row" alignItems="center" spacing={1.5} sx={{ px: 1 }}>
                                                        <Avatar
                                                            variant="rounded"
                                                            src={item.img}
                                                            sx={{ width: 44, height: 44, bgcolor: 'grey.100' }}
                                                        />
                                                        <Stack sx={{ flex: 1, minWidth: 0 }}>
                                                            <Typography variant="subtitle1" noWrap>
                                                                {item.premiumName}{item.color && item.color !== '0' ? ' (' + item.color + ')' : ''}
                                                            </Typography>
                                                            <Typography variant="subtitle2" sx={{ color: 'success.dark' }}>
                                                                {item.premium_id}
                                                            </Typography>
                                                        </Stack>
                                                        <Typography variant="h3">{item.qty}</Typography>
                                                    </Stack>
                                                    <Divider sx={{ my: 1.5 }} />
                                                </div>
                                            ))
                                        )
                                    ) : (
                                    Datasearch.map((item, index) => (
                                        <div key={index}>
                                            <Grid container direction="column" spacing={1}>
                                                <Grid item>
                                                    <Avatar variant="rounded" src={item?.images?.[0]?.img} sx={{ width: 40, height: 40, ml: 2 }} />
                                                </Grid>
                                                <Grid item>
                                                    <Grid container alignItems="center" justifyContent="space-between">
                                                        <Grid item><Typography variant="subtitle1">{item.productName + ' (' + item.color + ')'}</Typography></Grid>
                                                        <Grid item><Typography variant="h3">{item.qty}</Typography></Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item>
                                                    <Grid container alignItems="center" justifyContent="space-between">
                                                        <Grid item><Typography variant="subtitle2" sx={{ color: 'success.dark' }}>{item.model}</Typography></Grid>
                                                        <Grid item><Typography variant="subtitle2" sx={{ color: 'error.dark' }}>{'Order: ' + (item.requestproducts?.order || 0)}</Typography></Grid>
                                                    </Grid>
                                                </Grid>
                                                {typeFilter === 'all' && (
                                                    <Grid item>
                                                        <Grid container alignItems="center" justifyContent="flex-end" spacing={1}>
                                                            <Grid item><Typography variant="subtitle2" sx={{ color: 'info.dark' }}>{'Display: ' + (item.displayQty || 0)}</Typography></Grid>
                                                            {(item.repairedQty || 0) > 0 && (
                                                                <Grid item><Typography variant="subtitle2" sx={{ color: '#f57224' }}>{'Repaired: ' + item.repairedQty}</Typography></Grid>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                )}
                                            </Grid>
                                            <Divider sx={{ my: 1.5 }} />
                                        </div>
                                    ))
                                    )}
                                </PerfectScrollbar>
                            </Grid>
                        </Grid>
                    </CardContent>
        </MainCard>
    );
};

export default StockCard;
